import { Component, Input, OnChanges, SimpleChanges, ViewChild, ElementRef, OnInit } from '@angular/core';
import { PlessViewUtilsSub } from '../../kymw00/pless-view-utils-sub.service';
import { isArray } from 'util';

/**
 * 3桁0詰め編集テキストボックス
 *
 * @export
 * @class MarkCodeComponent
 * @extends {PlessInputTextDirective}
 * @implements {OnChanges}
 */
@Component({
  selector: 'app-mark-code',
  templateUrl: 'mark-code.component.html',
})
export class MarkCodeComponent implements OnInit, OnChanges {

  @ViewChild('label', { static: true }) public label: ElementRef;

  @Input() public subid: string = null;
  /** データ */
  @Input() Data: any;
  /** テキスト表示位置 */
  @Input() textAlign: string = <string>'';
  @Input() forcedEnabledMode: string = null;

  public labelText: string = <string>'';

  /**
   * 連携された値が変更された際に、メソッドを呼び出す
   *
   * @param {SimpleChanges} changes イベント引数
   * @memberof MarkCodeComponent
   */
  ngOnChanges(changes: SimpleChanges): void {
    Object.keys(changes).forEach((propName) => {
      switch (propName) {
        case 'Data':
          this.data = changes.Data.currentValue;
          break;
      }
    });
  }

  /**
   * 初期処理
   *
   * @memberof MarkCodeComponent
   */
  ngOnInit(): void {
    this.label.nativeElement.setAttribute('id', this.subid + '_sub');
    this.label.nativeElement.setAttribute('forcedEnabledMode', this.forcedEnabledMode);
  }

  /**
   * データ設定
   *
   * @memberof MarkCodeComponent
   */
  public set data(value: any) {
    if (isArray(value.MarkCode)) {
      this.labelText = PlessViewUtilsSub.zeroPadding(3, value.MarkCode[0]);
    } else {
      this.labelText = PlessViewUtilsSub.zeroPadding(3, value.MarkCode);
    }
  }

}
